import { useOktaAuth } from '@okta/okta-react';
import { useOktaProfile } from '@optools/hooks/useOktaProfile';
import { selectConfig } from '@optools/store/configApiSlice';
import { useAppSelector } from '@optools/store/hooks';
import { useTeamsQuery } from '@optools/store/statsApiSlice';
import { RouterProvider, useRouter } from '@tanstack/react-router';

export function App({ router }: { router: ReturnType<typeof useRouter> }) {
  const config = useAppSelector(selectConfig);
  const auth = useOktaAuth();
  const { profile } = useOktaProfile();
  // Hydrates teams data early to avoid flickering
  useTeamsQuery();

  return <RouterProvider context={{ auth, config, profile }} router={router} />;
}
